import axios from 'axios';

const instance = axios.create({
    baseURL: 'http://localhost:4000' //backend server runs on port 4000
});

export default instance;